var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarDays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5H14.5C15.0523 2.5 15.5 2.94772 15.5 3.5V14.5C15.5 15.0523 15.0523 15.5 14.5 15.5H1.5C0.947715 15.5 0.5 15.0523 0.5 14.5V3.5C0.5 2.94772 0.947715 2.5 1.5 2.5Z",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.5H0.5",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4V0.5",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4V0.5",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9C12.2994 9 12.3478 9.01466 12.3889 9.04213C12.43 9.0696 12.462 9.10865 12.481 9.15433C12.4999 9.20001 12.5048 9.25028 12.4952 9.29877C12.4855 9.34727 12.4617 9.39181 12.4268 9.42678C12.3918 9.46174 12.3473 9.48555 12.2988 9.4952C12.2503 9.50484 12.2 9.49989 12.1543 9.48097C12.1086 9.46205 12.0696 9.43 12.0421 9.38889C12.0147 9.34778 12 9.29945 12 9.25C12 9.1837 12.0263 9.12011 12.0732 9.07322C12.1201 9.02634 12.1837 9 12.25 9Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.5C12.2994 12.5 12.3478 12.5147 12.3889 12.5421C12.43 12.5696 12.462 12.6086 12.481 12.6543C12.4999 12.7 12.5048 12.7503 12.4952 12.7988C12.4855 12.8473 12.4617 12.8918 12.4268 12.9268C12.3918 12.9617 12.3473 12.9855 12.2988 12.9952C12.2503 13.0048 12.2 12.9999 12.1543 12.981C12.1086 12.962 12.0696 12.93 12.0421 12.8889C12.0147 12.8478 12 12.7994 12 12.75C12 12.6837 12.0263 12.6201 12.0732 12.5732C12.1201 12.5263 12.1837 12.5 12.25 12.5Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9C8.04945 9 8.09778 9.01466 8.13889 9.04213C8.18 9.0696 8.21205 9.10865 8.23097 9.15433C8.24989 9.20001 8.25484 9.25028 8.2452 9.29877C8.23555 9.34727 8.21174 9.39181 8.17678 9.42678C8.14181 9.46174 8.09727 9.48555 8.04877 9.4952C8.00028 9.50484 7.95001 9.49989 7.90433 9.48097C7.85865 9.46205 7.8196 9.43 7.79213 9.38889C7.76466 9.34778 7.75 9.29945 7.75 9.25C7.75 9.1837 7.77634 9.12011 7.82322 9.07322C7.87011 9.02634 7.9337 9 8 9Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C8.04945 12.5 8.09778 12.5147 8.13889 12.5421C8.18 12.5696 8.21205 12.6086 8.23097 12.6543C8.24989 12.7 8.25484 12.7503 8.2452 12.7988C8.23555 12.8473 8.21174 12.8918 8.17678 12.9268C8.14181 12.9617 8.09727 12.9855 8.04877 12.9952C8.00028 13.0048 7.95001 12.9999 7.90433 12.981C7.85865 12.962 7.8196 12.93 7.79213 12.8889C7.76466 12.8478 7.75 12.7994 7.75 12.75C7.75 12.6837 7.77634 12.6201 7.82322 12.5732C7.87011 12.5263 7.9337 12.5 8 12.5Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9C3.79945 9 3.84778 9.01466 3.88889 9.04213C3.93001 9.0696 3.96205 9.10865 3.98097 9.15433C3.99989 9.20001 4.00484 9.25028 3.9952 9.29877C3.98555 9.34727 3.96174 9.39181 3.92678 9.42678C3.89181 9.46174 3.84727 9.48555 3.79877 9.4952C3.75028 9.50484 3.70001 9.49989 3.65433 9.48097C3.60865 9.46205 3.5696 9.43 3.54213 9.38889C3.51466 9.34778 3.5 9.29945 3.5 9.25C3.5 9.1837 3.52634 9.12011 3.57322 9.07322C3.62011 9.02634 3.6837 9 3.75 9Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.5C3.79945 12.5 3.84778 12.5147 3.88889 12.5421C3.93001 12.5696 3.96205 12.6086 3.98097 12.6543C3.99989 12.7 4.00484 12.7503 3.9952 12.7988C3.98555 12.8473 3.96174 12.8918 3.92678 12.9268C3.89181 12.9617 3.84727 12.9855 3.79877 12.9952C3.75028 13.0048 3.70001 12.9999 3.65433 12.981C3.60865 12.962 3.5696 12.93 3.54213 12.8889C3.51466 12.8478 3.5 12.7994 3.5 12.75C3.5 12.6837 3.52634 12.6201 3.57322 12.5732C3.62011 12.5263 3.6837 12.5 3.75 12.5Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDays);
export default __webpack_public_path__ + "static/media/calendar-days.8bd83cab2418e5cae72ff7d16f94e4a5.svg";
export { ForwardRef as ReactComponent };